import styled, { createGlobalStyle } from "styled-components";

// const tabletQuery =
//   "(max-width: 768px) and (min-width: 491px), (min-width: 769px) and (orientation: portrait)";
// const desktopQuery = "(min-width: 769px) and (orientation: landscape)";
// const mobileQuery = "(max-width: 491px)";

export const GlobalStyles = createGlobalStyle`

*{
  margin:0;
  padding:0;
  font-family: helvetica-neue-regular
}

sup{
  font-size:10px;
}

p{
  line-height:1.5;
}

html, body {
    margin: 0;
    padding: 0;
    background-color:black;
    font-family: helvetica-neue-regular
  }   
  body {    
    height: ${window.innerHeight}px;
    text-rendering: optimizeLegibility;
    font-size: 24px;
    overflow:hidden;
  }
  a {
    text-decoration: none;
  }
  @media screen and (min-width: 320px) {
    html, body, input {      
      font-size: calc(14px + (24 - 14) * ((100vw - 320px) / (1920 - 320)));
    }
  }

  // .swiper-wrapper {
  //   transform: translate3d(0px, 0, 0) !important;
  //   transition-property:none
  // }
  .swiper-wrapper, .swiper-slide, .swiper-slide-active {
    //  transform: ${props => (props.allowSwipe ? "null" : "translate3d(0px, 0, 0) !important")};
    //  transition-property:none
//     -o-transform: ${props => (props.allowSwipe ? "translate3d(506px, 0, 0)" : "none !important")};
// -moz-transform: ${props => (props.allowSwipe ? "translate3d(506px, 0, 0)" : "none !important")};
// -ms-transform: ${props => (props.allowSwipe ? "translate3d(506px, 0, 0)" : "none !important")};
// -webkit-transform: ${props => (props.allowSwipe ? "translate3d(506px, 0, 0)" : "none !important")};

   }
  .swiper-pagination {
    display:none
  }

  .load-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: ${window.innerHeight}px;
    overflow: hidden;
    z-index: 10;
    pointer-events: none;
    overflow: hidden;
  }


.loader {
  position: relative;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  height: ${window.innerHeight}px;
  background-color: #161616;
  margin-left: 100vw;
  /* overflow: hidden; */
}

.load-pointer {
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 0;
  background-color: #161616;
  top: 70%;
  left: 0;
  opacity: 0;
  display: flex;
  align-items: center;
  padding: 0 0 0 15px;
  cursor: pointer;
}

.loader-bottom {
  position: relative;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  height: 100%;
  background-color: #161616;
  margin-top: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;

  @font-face {
    font-name: alternate_gothic_bold;
    src: url(/assets/fonts/Alternate-Gothic-No-2-BT.ttf);
  }

  font-family: alternate_gothic_bold;
}

  @media(min-width: 786px){
    html{
      background-color:black;
      display:flex;
      align-items:center;
      justify-content:center;
    }
    #root{
      width:495px;
      margin:auto;
      position:relative
    }
  }


  .swiper-button-prev{
    position:absolute;
    top:${window.innerHeight/2}px;
    z-index:100;

    @media(max-width:786px){
      display:none
    }

  }
  .swiper-button-next{
    position:absolute;
    top:${window.innerHeight/2}px;
    z-index:100;

    @media(max-width:786px){
      display:none
    }
  }


  @media (max-width: 430px){
    sup{
      font-size:8px;
    }
  }

`

export const ComicContainer = styled.section`
  width: 100%;
  height:100%;
  position: relative;
  opacity: 1;
`